import React from 'react';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle } = FiIcons;

/**
 * SafeIcon component to render icons safely.
 * Follows strict import guidelines to prevent network errors during deployment.
 */
const SafeIcon = ({ icon: IconComponent, ...props }) => {
  if (!IconComponent) {
    return <FiAlertTriangle {...props} />;
  }

  try {
    return <IconComponent {...props} />;
  } catch (e) {
    console.error("Error rendering icon:", e);
    return <FiAlertTriangle {...props} />;
  }
};

export default SafeIcon;